export default __webpack_public_path__ + "static/media/art-brw-poster-1.8ab306ba.jpg";